import React from 'react'
import { useTranslation } from 'react-i18next'

export default function HelpPage() {
  const { t } = useTranslation()
  return (
    <div className="container mx-auto px-4 py-10 max-w-3xl">
      <h1 className="text-3xl font-bold mb-2">{t('help.title')}</h1>
      <p className="text-slate-600 mb-8">{t('help.subtitle')}</p>

      <div className="prose">
        <h2>{t('help.search.title')}</h2>
        <p>{t('help.search.intro')}</p>
        <ol>
          <li>{t('help.search.steps.1')}</li>
          <li>{t('help.search.steps.2')}</li>
          <li>{t('help.search.steps.3')}</li>
          <li>{t('help.search.steps.4')}</li>
        </ol>
        <p className="bg-emerald-50 border border-emerald-200 p-3 rounded">{t('help.search.tips')}</p>

        <h3>{t('help.search.images.title')}</h3>
        <p>{t('help.search.images.desc')}</p>
        <ul>
          <li>{t('help.search.images.items.1')}</li>
          <li>{t('help.search.images.items.2')}</li>
          <li>{t('help.search.images.items.3')}</li>
        </ul>

        <h2>{t('help.accessibility.title')}</h2>
        <p>{t('help.accessibility.intro')}</p>
        <ol>
          <li>{t('help.accessibility.steps.1')}</li>
          <li>{t('help.accessibility.steps.2')}</li>
          <li>{t('help.accessibility.steps.3')}</li>
          <li>{t('help.accessibility.steps.4')}</li>
        </ol>
        <p className="bg-slate-50 border border-slate-200 p-3 rounded">{t('help.accessibility.note')}</p>

        <h2>{t('help.subscription.title')}</h2>
        <p>{t('help.subscription.intro')}</p>
        <ul>
          <li>{t('help.subscription.items.1')}</li>
          <li>{t('help.subscription.items.2')}</li>
          <li>{t('help.subscription.items.3')}</li>
        </ul>

        <h2>{t('help.categories.title')}</h2>
        <p>{t('help.categories.intro')}</p>
        <ul>
          <li>{t('help.categories.items.1')}</li>
          <li>{t('help.categories.items.2')}</li>
          <li>{t('help.categories.items.3')}</li>
        </ul>

        <h2>{t('help.troubleshooting.title')}</h2>
        <ul>
          <li>{t('help.troubleshooting.items.1')}</li>
          <li>{t('help.troubleshooting.items.2')}</li>
          <li>{t('help.troubleshooting.items.3')}</li>
          <li>{t('help.troubleshooting.items.4')}</li>
        </ul>

        <h2>{t('help.contact.title')}</h2>
        <p>{t('help.contact.desc')}</p>
      </div>
    </div>
  )
}


